import { render, staticRenderFns } from "./TableTypeUpdateBeneficiary.vue?vue&type=template&id=0c308b34"
import script from "./TableTypeUpdateBeneficiary.vue?vue&type=script&lang=js"
export * from "./TableTypeUpdateBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports